import { ZfBox, ZfIcon } from '@zafire/react';
import type { CSSProperties, FunctionComponent } from 'react';
import { X_AXIS_OFFSET } from '../../../config/constants';
import { getZfLifeEventIconForTile } from '../../icons/iconUtils';

const bubbleBorder = `1px solid var(--border-color-action-normal)`;
const bubbleSize = 25;
const bubbleSizeClientOutput = bubbleSize * 2;

const getIconWrapperStyle = (clientOutput: boolean): CSSProperties => ({
    width: clientOutput ? bubbleSizeClientOutput : bubbleSize,
    height: clientOutput ? bubbleSizeClientOutput : bubbleSize,
    backgroundColor: 'var(--bg-color-default-normal)',
    borderRadius: '50%',
    border: '1px solid var(--border-color-action-normal)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

interface IProps {
    topicKey?: string;
    positionY: number;
    positionX: number;
    showSingleIcon: boolean;
    clientOutput?: boolean;
    isMaturity?: boolean;
    amountEvents?: number;
}

export const CashEventIcon: FunctionComponent<IProps> = ({ topicKey, positionY, positionX, showSingleIcon, clientOutput, isMaturity, amountEvents }) => {
    const lollipopPosition = (positionX: number): number => {
        const floored = Math.floor(positionX);
        const diff = positionX - floored;
        if (diff > 0.6) {
            return Math.round(positionX);
        }

        return floored;
    };

    const height = (clientOutput: boolean) => (clientOutput ? X_AXIS_OFFSET : X_AXIS_OFFSET / 2) - (clientOutput ? bubbleSizeClientOutput : bubbleSize) / 2;

    return (
        <ZfBox
            style={{
                position: 'absolute',
                bottom: positionY,
                left: `calc(${lollipopPosition(positionX)}px - ${(clientOutput ? bubbleSizeClientOutput : bubbleSize) / 2}px)`,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            {showSingleIcon ? (
                <>
                    <ZfBox style={getIconWrapperStyle(!!clientOutput)}>
                        <ZfIcon className="cash-event-icon--royal-blue" size="small" name={getZfLifeEventIconForTile(isMaturity ? 'MATURITY' : topicKey)} />
                    </ZfBox>
                    <ZfBox
                        style={{
                            borderLeft: bubbleBorder,
                            width: 2,
                            height: height(!!clientOutput),
                        }}
                    />
                </>
            ) : (
                <>
                    <ZfBox style={getIconWrapperStyle(!!clientOutput)}>{amountEvents}</ZfBox>
                    <ZfBox
                        style={{
                            borderLeft: bubbleBorder,
                            width: 2,
                            height: height(!!clientOutput),
                        }}
                    />
                </>
            )}
        </ZfBox>
    );
};
